import { getCurrentDate } from './apiSport';
const mqtt = require('mqtt');
const pako = require('pako');

// MQTT Configuration
const MQTT_BROKER_URL = `${process.env.REACT_APP_MQTT_PROTOCOL}://${process.env.REACT_APP_MQTT_HOST}${process.env.REACT_APP_MQTT_PATH}`;
const clientId = localStorage.getItem('mqtt_client_id') || `chatboxn_${Math.random().toString(16).slice(3)}`;
if (!localStorage.getItem('mqtt_client_id')) {
  localStorage.setItem('mqtt_client_id', clientId);
}
const MQTT_OPTIONS = {
  clientId,
  clean: false,
  connectTimeout: 4000,
  reconnectPeriod: 1000,
};

let client;
let isSubscribed = false; // Cờ kiểm tra đăng ký chủ đề

// Decompress the message
const decompressMessage = compressedMessage => {
  try {
    const compressedData = new Uint8Array(compressedMessage);
    const decompressedData = pako.inflate(compressedData, { to: 'string' });
    return JSON.parse(decompressedData);
  } catch (error) {
    console.log(`${getCurrentDate()} ChatBox: Error decompressing message:`, error);
    return null;
  }
};

// Connect to MQTT Broker
export const connectMqtt = (onMessageCallback, topic) => {
  if (client && client.connected) {
    console.log(`${getCurrentDate()} ChatBox: Already connected ${topic} ${showLastNChars(clientId)}`);
    return; // Tránh kết nối lại nếu đã kết nối
  }

  client = mqtt.connect(MQTT_BROKER_URL, MQTT_OPTIONS);

  client.on('connect', () => {
    console.log(`${getCurrentDate()} ChatBox: Connected ${topic} ${showLastNChars(clientId)}`);
    if (topic && !isSubscribed) {
      subscribeToTopic(topic, onMessageCallback); // Pass callback to subscription
    }
  });

  client.on('reconnect', () => {
    console.log(`${getCurrentDate()} ChatBox: Reconnecting ${topic} ${isSubscribed} ${showLastNChars(clientId)}`);
    if (topic && !isSubscribed) {
      subscribeToTopic(topic, onMessageCallback); // Pass callback to subscription
    } else if (!topic) {
      console.log(`${getCurrentDate()} ChatBox: No topic provided for subscription.`);
    } else {
      // Khi isSubscribed là true, bạn không cần phải đăng ký lại, nhưng vẫn có thể muốn ghi log hoặc xử lý khác
      console.log(`${getCurrentDate()} ChatBox: Already subscribed to ${topic}.`);
    }
  });

  client.on('error', err => {
    console.log('ChatBox: MQTT Error:', err);
    client.end();
  });

  client.on('message', (topic, message) => {
    const parsedMessage = decompressMessage(message);
    if (parsedMessage) {
      if (onMessageCallback) {
        onMessageCallback(topic, parsedMessage); // Call the provided callback
      } else {
        console.log(`${getCurrentDate()} ChatBox: No onMessageCallback provided.`);
      }
    }
  });
};

// Subscribe to a Topic
export const subscribeToTopic = (topic, onMessageCallback) => {
  if (client && client.connected) {
    client.subscribe(topic, { qos: 2 }, (err, granted) => {
      if (err) {
        console.log(`${getCurrentDate()} ChatBox: Subscription error for ${topic} - qos=2:`, err);
      } else {
        isSubscribed = true;
        console.log(`${getCurrentDate()} ChatBox: Subscribed ${topic} ${showLastNChars(clientId)}`);
      }
    });
  } else {
    console.log(`${getCurrentDate()} ChatBox: Client not connected. Cannot subscribe to topic: ${showLastNChars(topic)}`);
    connectMqtt(onMessageCallback, topic); // Tự động kết nối lại nếu không kết nối
  }
};

// Publish a Message
export const publishMessage = (topic, message) => {
  if (client && client.connected) {
    client.publish(topic, message, err => {
      if (err) {
        console.log(`ChatBox: Publish error to ${topic}:`, err);
      } else {
        console.log(`ChatBox: Message published to ${topic}: ${message}`);
      }
    });
  } else {
    console.log(`${getCurrentDate()} ChatBox: Client not connected. Cannot publish message to topic: ${showLastNChars(topic)}`);
  }
};

// Disconnect MQTT
export const disconnectMqtt = () => {
  if (client) {
    client.end(() => {
      console.log(`${getCurrentDate()} ChatBox: Disconnected from MQTT Broker`);
    });
  }
};

export const showLastNChars = (inputString, length = 5, dots = '...') => {
  return `${dots}${inputString.slice(-length)}`;
}
